import { writable } from "svelte/store";
let MenuItemStore;
export default MenuItemStore = writable([]);
